const config = require("../config.js");
const version = require("../../version.json");
module.exports.keyboardMap = [
  "",
  "",
  "",
  "CANCEL",
  "",
  "",
  "HELP",
  "",
  "BACK_SPACE",
  "TAB",
  "",
  "",
  "CLEAR",
  "ENTER",
  "ENTER_SPECIAL",
  "",
  "SHIFT",
  "CONTROL",
  "ALT",
  "PAUSE",
  "CAPS_LOCK",
  "KANA",
  "EISU",
  "JUNJA",
  "FINAL",
  "HANJA",
  "",
  "ESCAPE",
  "CONVERT",
  "NONCONVERT",
  "ACCEPT",
  "MODECHANGE",
  "SPACE",
  "PAGE_UP",
  "PAGE_DOWN",
  "END",
  "HOME",
  "LEFT",
  "UP",
  "RIGHT",
  "DOWN",
  "SELECT",
  "PRINT",
  "EXECUTE",
  "PRINTSCREEN",
  "INSERT",
  "DELETE",
  "",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "COLON",
  "SEMICOLON",
  "LESS_THAN",
  "EQUALS",
  "GREATER_THAN",
  "QUESTION_MARK",
  "AT",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "OS_KEY",
  "",
  "CONTEXT_MENU",
  "",
  "SLEEP",
  "NUMPAD0",
  "NUMPAD1",
  "NUMPAD2",
  "NUMPAD3",
  "NUMPAD4",
  "NUMPAD5",
  "NUMPAD6",
  "NUMPAD7",
  "NUMPAD8",
  "NUMPAD9",
  "MULTIPLY",
  "ADD",
  "SEPARATOR",
  "SUBTRACT",
  "DECIMAL",
  "DIVIDE",
  "F1",
  "F2",
  "F3",
  "F4",
  "F5",
  "F6",
  "F7",
  "F8",
  "F9",
  "F10",
  "F11",
  "F12",
  "F13",
  "F14",
  "F15",
  "F16",
  "F17",
  "F18",
  "F19",
  "F20",
  "F21",
  "F22",
  "F23",
  "F24",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "NUM_LOCK",
  "SCROLL_LOCK",
  "WIN_OEM_FJ_JISHO",
  "WIN_OEM_FJ_MASSHOU",
  "WIN_OEM_FJ_TOUROKU",
  "WIN_OEM_FJ_LOYA",
  "WIN_OEM_FJ_ROYA",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "CIRCUMFLEX",
  "EXCLAMATION",
  "DOUBLE_QUOTE",
  "HASH",
  "DOLLAR",
  "PERCENT",
  "AMPERSAND",
  "UNDERSCORE",
  "OPEN_PAREN",
  "CLOSE_PAREN",
  "ASTERISK",
  "PLUS",
  "PIPE",
  "HYPHEN_MINUS",
  "OPEN_CURLY_BRACKET",
  "CLOSE_CURLY_BRACKET",
  "TILDE",
  "",
  "",
  "",
  "",
  "VOLUME_MUTE",
  "VOLUME_DOWN",
  "VOLUME_UP",
  "",
  "",
  ";",
  "=",
  ",",
  "MINUS",
  "PERIOD",
  "SLASH",
  "BACK_QUOTE",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "[",
  "\\",
  "]",
  "QUOTE",
  "",
  "META",
  "ALTGR",
  "",
  "WIN_ICO_HELP",
  "WIN_ICO_00",
  "",
  "WIN_ICO_CLEAR",
  "",
  "",
  "WIN_OEM_RESET",
  "WIN_OEM_JUMP",
  "WIN_OEM_PA1",
  "WIN_OEM_PA2",
  "WIN_OEM_PA3",
  "WIN_OEM_WSCTRL",
  "WIN_OEM_CUSEL",
  "WIN_OEM_ATTN",
  "WIN_OEM_FINISH",
  "WIN_OEM_COPY",
  "WIN_OEM_AUTO",
  "WIN_OEM_ENLW",
  "WIN_OEM_BACKTAB",
  "ATTN",
  "CRSEL",
  "EXSEL",
  "EREOF",
  "PLAY",
  "ZOOM",
  "",
  "PA1",
  "WIN_OEM_CLEAR",
  "",
];
module.exports.getB64Size = function () {};
module.exports.compressNumArray = function (l) {
  var m = null;
  var p = true;
  for (var q = l.length - 1; q >= 0; --q) {
    if (typeof l[q] == "number") {
      if (m === null) {
        m = 0;
      } else {
        m++;
        l[q] = m;
        l.splice(q + 1);
      }
    } else {
      m = null;
      p = false;
    }
  }
  if (p) {
    return l[0];
  } else {
    return l;
  }
};
Number.prototype.round = function (l) {
  return Math.round(this * Math.pow(10, l || 0)) / Math.pow(10, l || 0);
};
String.prototype.escape = function () {
  return (this + "").replace(/[\\"']/g, "\\$&").replace(/\u0000/g, "\\0");
};
Number.prototype.roundToNearest = function (l) {
  if (this > 0) {
    return Math.ceil(this / l) * l;
  } else if (this < 0) {
    return Math.floor(this / l) * l;
  } else {
    return this;
  }
};
Number.prototype.countDecimals = function () {
  if (Math.floor(this.valueOf()) === this.valueOf()) {
    return 0;
  } else {
    return this.toString().split(".")[1].length || 0;
  }
};
module.exports.capFirst = function (l) {
  return l.charAt(0).toUpperCase() + l.slice(1);
};
module.exports.isURL = function (l) {
  try {
    return /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(\:\d+)?(\/[-a-z\d%@_.~+&:]*)*(\?[;&a-z\d%@_.,~+&:=-]*)?(\#[-a-z\d_]*)?$/i.test(
      l,
    );
  } catch (m) {}
  return false;
};
module.exports.arrayAverage = function (l) {
  var m = 0;
  for (var p = 0; p < l.length; p++) {
    m += l[p];
  }
  return m / l.length;
};
module.exports.countInArray = function (l, m) {
  var p = 0;
  for (var q = 0; q < l.length; q++) {
    if (l[q] === m) {
      p++;
    }
  }
  return p;
};
module.exports.formatNum = function (l, m = 1) {
  var p = Math.floor(Math.log(Math.abs(l)) / Math.log(1000));
  var q = "kmb"[p - 1];
  if (q) {
    return (l / Math.pow(1000, p)).toFixed(m) + q;
  } else {
    return "" + l;
  }
};
module.exports.randFloat = function (l, m) {
  return Math.random() * (m - l) + l;
};
module.exports.randInt = function (l, m) {
  return Math.floor(Math.random() * (m - l + 1)) + l;
};
module.exports.getPercentDiff = function (l, m) {
  return Math.round(((m - l) / l) * 100, 1);
};
module.exports.calcPercent = function (l, m) {
  return (l / 100) * m;
};
module.exports.getRandom = function (l) {
  return l[module.exports.randInt(0, l.length - 1)];
};
module.exports.distance2D = function (l, m, p, q) {
  return Math.sqrt((p -= l) * p + (q -= m) * q);
};
module.exports.getD3D = function (m, p, q, u, v, w) {
  var x = m - u;
  var y = p - v;
  var z = q - w;
  return Math.sqrt(x * x + y * y + z * z);
};
module.exports.getAnglesSSS = function (l, m, p) {
  var q = Math.acos((m * m + p * p - l * l) / (m * 2 * p));
  var u = Math.acos((p * p + l * l - m * m) / (p * 2 * l));
  var v = Math.PI - q - u;
  return [-q - Math.PI / 2, u, v];
};
module.exports.angleDistance = function (l, m) {
  return Math.atan2(Math.sin(m - l), Math.cos(l - m));
};
module.exports.getAngleDist2 = function (l, m) {
  var p = Math.abs(m - l) % (Math.PI * 2);
  if (p > Math.PI) {
    return Math.PI * 2 - p;
  } else {
    return p;
  }
};
module.exports.getXDire = function (m, p, q, u, v, w) {
  var x = Math.abs(p - v);
  var y = module.exports.getD3D(m, p, q, u, v, w);
  return Math.asin(x / y) * (p > v ? -1 : 1);
};
module.exports.toRad = function (l) {
  return l * (Math.PI / 180);
};
module.exports.direction2D = function (l, m, p, q) {
  return Math.atan2(m - q, l - p);
};
module.exports.getDrs = function (l, m) {
  var p = m.x - l.x;
  var q = m.y - l.y;
  var u = m.z - l.z;
  var v = Math.sqrt(p * p + u * u);
  var w = -Math.atan2(q, v);
  return [-Math.atan2(-p, u), w];
};
module.exports.lerp = function (l, m, p) {
  return l + (m - l) * p;
};
module.exports.orderByDst = function (l, m) {
  return l.dst - m.dst;
};
module.exports.orderByNum = function (l, m) {
  return l - m;
};
module.exports.orderByScore = function (l, m) {
  return m.score - l.score;
};
module.exports.orderByKills = function (l, m) {
  return m.kills - l.kills;
};
module.exports.capFirst = function (l) {
  return l.charAt(0).toUpperCase() + l.slice(1);
};
module.exports.truncateText = function (l, m) {
  if (l.length > m) {
    return l.substring(0, m) + "...";
  } else {
    return l;
  }
};
module.exports.cleanseString = function (l) {
  if (l) {
    return l.replace(/['"]+/g, "");
  } else {
    return l;
  }
};
module.exports.randomString = function (l) {
  var m = "";
  var p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (var q = 0; q < l; q++) {
    m += p.charAt(Math.floor(Math.random() * p.length));
  }
  return m;
};
module.exports.formatNumCash = function (l) {
  return parseFloat(Math.round(l * 100) / 100).toFixed(2);
};
module.exports.formatConstName = function (l) {
  return l
    .toLowerCase()
    .split("_")
    .map((m) => m.slice(0, 1).toUpperCase() + m.slice(1).toLowerCase())
    .join(" ");
};
module.exports.getKeyName = function (l) {
  if (l < 0) {
    return "UNBOUND";
  } else if (l == 20000) {
    return "SCROLL";
  } else if (l > 10000) {
    return "M" + (l - 10000);
  } else {
    return module.exports.keyboardMap[l];
  }
};
module.exports.formatNumCash = function (l) {
  return parseFloat(Math.round(l * 100) / 100).toFixed(2);
};
var h = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
module.exports.getDate = function (l) {
  if (!l) {
    return "None";
  }
  l = l.split(/[-A-Z :\.]/i);
  var m = new Date(l[0], --l[1], l[2], l[3], l[4], l[5]);
  var p = new Date(m.getTime());
  return (
    p.getDate() + " " + h[p.getMonth()].slice(0, 3) + " " + p.getFullYear()
  );
};
module.exports.getGraphDate = function (l, m) {
  return ("0" + l).slice(-2) + " " + h[m].slice(0, 3);
};
module.exports.getTime = function (l, m) {
  if (l == "inf") {
    return "Infinite";
  }
  var p = parseInt((l % 1000) / 100);
  var q = parseInt((l / 1000) % 60);
  var u = parseInt((l / 60000) % 60);
  return (
    (u = u < 10 ? "0" + u : u) +
    ":" +
    (q = q < 10 ? "0" + q : q) +
    (m ? "." + p : "")
  );
};
module.exports.commaFormatNum = function (l) {
  return l.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
module.exports.commaNumber = function (l) {
  return (l = l || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
module.exports.getReadableTime = function (l, m) {
  var p = Math.floor(l / 1000);
  var q = Math.floor(p / 60);
  p %= 60;
  var u = Math.floor(q / 60);
  q %= 60;
  var v = Math.floor(u / 24);
  return (
    (v ? v + "d " : "") +
    ((u %= 24) ? u + "h " : "") +
    (q || 0) +
    "m " +
    (m ? p + "s" : "")
  );
};
module.exports.getRoundTim = function (l) {
  var m = (l / 1000) | 0;
  var p = (m / 60) | 0;
  m -= p * 60;
  var q = (p / 60) | 0;
  p -= q * 60;
  var u = (q / 24) | 0;
  q -= u * 24;
  if (u) {
    return u + " Day" + (u > 1 ? "s " : " ") + q + " Hour" + (q > 1 ? "s" : "");
  } else if (q) {
    return (
      q + " Hour" + (q > 1 ? "s " : " ") + p + " Minute" + (p > 1 ? "s" : "")
    );
  } else {
    return p + " Minute" + (p > 1 ? "s" : "");
  }
};
module.exports.getReadableTime2 = function (l) {
  if (l < 0) {
    return "just now";
  }
  var m = Math.floor(l / 1000);
  var p = Math.floor(m / 60);
  var q = Math.floor(p / 60);
  p %= 60;
  var u = Math.floor(q / 24);
  q %= 24;
  if (u) {
    return u + "d ago";
  } else if (q) {
    return q + "h ago";
  } else if (p) {
    return p + "m ago";
  } else {
    return "just now";
  }
};
module.exports.getTimeH = function (l) {
  parseInt((l % 1000) / 100);
  var m = Math.floor((l / 1000) % 60);
  var p = Math.floor((l / 60000) % 60);
  var q = Math.floor((l / 3600000) % 24);
  return (
    (q = q < 10 ? "0" + q : q) +
    ":" +
    (p = p < 10 ? "0" + p : p) +
    ":" +
    (m = m < 10 ? "0" + m : m)
  );
};
module.exports.scrambleS = function (l) {
  if (l && l.replace) {
    return l.replace(/.(.)?/g, "$1") + ("d" + l).replace(/.(.)?/g, "$1");
  } else {
    return l;
  }
};
module.exports.fixTo = function (l, m) {
  return parseFloat(l.toFixed(m));
};
module.exports.fixFloat = function (l, m) {
  return +parseFloat(l).toFixed(m);
};
module.exports.sanitizeStr = function (l) {
  if (l && l.replace) {
    return l.replace(/<|>|&/g, "").replace(/[^\x00-\x7F]/g, "");
  } else {
    return l;
  }
};
module.exports.limit = function (l, m) {
  if (l < -m) {
    return -m;
  } else if (l > m) {
    return m;
  } else {
    return l;
  }
};
module.exports.limitMM = function (l, m, p) {
  if (l < m) {
    return m;
  } else if (l > p) {
    return p;
  } else {
    return l;
  }
};
module.exports.limitMMD = function (l, m, p, q) {
  if (l < m || l > p) {
    return q;
  } else {
    return l;
  }
};
module.exports.inRange = function (l, m, p) {
  return l >= m && l <= p;
};
module.exports.cropVal = function (l, m) {
  if (l <= m && l >= -m) {
    return 0;
  } else {
    return l;
  }
};
module.exports.isNumber = function (l) {
  return l != null && typeof l == "number" && !isNaN(l) && isFinite(l);
};
module.exports.arrayInts = function (l) {
  for (var m = 0; m < l.length; ++m) {
    if (!module.exports.isNumber(l[m])) {
      return false;
    }
  }
  return true;
};
module.exports.isArray = function (l) {
  return !!l && l.constructor === Array;
};
module.exports.isString = function (l) {
  return l && typeof l == "string";
};
module.exports.isHexColor = function (l) {
  return /^#([0-9A-F]{3}){1,2}$/i.test(l);
};
module.exports.emptyString = function (l) {
  return !l || l.length === 0 || /^\s*$/.test(l) || !l.trim();
};
module.exports.compareString = function (l, m) {
  return (
    typeof l == "string" &&
    typeof m == "string" &&
    (l.toLowerCase().indexOf(m.toLowerCase()) >= 0 ||
      m.toLowerCase().indexOf(l.toLowerCase()) >= 0)
  );
};
module.exports.shuffleArray = function (l) {
  for (let m = l.length; m--; ) {
    const p = Math.floor(Math.random() * (m + 1));
    [l[m], l[p]] = [l[p], l[m]];
  }
  return l;
};
module.exports.lineInRect = function (q, w, x, z, A, B, C, D, E, F, G, H) {
  var I = (C - q) * z;
  var J = (F - q) * z;
  var K = (E - x) * B;
  var L = (H - x) * B;
  var M = (D - w) * A;
  var N = (G - w) * A;
  var O = Math.max(Math.max(Math.min(I, J), Math.min(K, L)), Math.min(M, N));
  var P = Math.min(Math.min(Math.max(I, J), Math.max(K, L)), Math.max(M, N));
  return !(P < 0) && !(O > P) && O;
};
module.exports.similar = function (l, m, p) {
  p = p || 0;
  return Math.abs(l - m) <= p;
};
module.exports.pointInBox3D = function (l, m, p, q, u) {
  u = u || 0;
  return (
    l >= q.x - q.width - u &&
    l <= q.x + q.width + u &&
    m >= q.y - q.height - u &&
    m <= q.y + q.height + u &&
    p >= q.z - q.length - u &&
    p <= q.z + q.length + u
  );
};
module.exports.pointInBox = function (l, m, p, q, u, v, w) {
  if (w) {
    return l >= p && l <= u && m >= q && m <= v;
  } else {
    return l > p && l < u && m > q && m < v;
  }
};
module.exports.sharePos = function (l, m, p) {
  p = p || 0;
  return (
    Math.abs(l.x - m.x) <= p &&
    Math.abs(l.y - m.y) <= p &&
    Math.abs(l.z - m.z) <= p &&
    Math.abs(l.d - m.d) <= p
  );
};
module.exports.cdv = {
  x: "width",
  y: "height",
  z: "length",
};
module.exports.boxIntersection = function (q, z, A, B, C) {
  var D = module.exports.cdv[A];
  var E = module.exports.cdv[B];
  var F = q[A] - q[D] - 0.1;
  var G = z[A] - z[D] - 0.1;
  var H = q[A] + q[D] + 0.1;
  var I = z[A] + z[D] + 0.1;
  var J = q[B] - q[E] - 0.1;
  var K = z[B] - z[E] - 0.1;
  var L = q[B] + q[E] + 0.1;
  var M = z[B] + z[E] + 0.1;
  var N = Math.max(F, G);
  var O = Math.min(H, I);
  if (O >= N) {
    var P = Math.max(J, K);
    var Q = Math.min(L, M);
    if (Q >= P) {
      var R = [
        {
          [A]: N,
          [B]: P,
          d: C[0],
        },
        {
          [A]: O,
          [B]: Q,
          d: C[1],
        },
        {
          [A]: N,
          [B]: Q,
          d: C[2],
        },
        {
          [A]: O,
          [B]: P,
          d: C[3],
        },
      ];
      for (var S = R.length - 1; S >= 0; --S) {
        if (
          (R[S][A] == H && R[S][A] == I) ||
          (R[S][A] == F && R[S][A] == G) ||
          (R[S][B] == L && R[S][B] == M) ||
          (R[S][B] == J && R[S][B] == K) ||
          module.exports.pointInBox(R[S][A], R[S][B], F, J, H, L) ||
          module.exports.pointInBox(R[S][A], R[S][B], G, K, I, M)
        ) {
          R[S].dontUse = true;
        }
      }
      return R;
    }
  }
  return null;
};
module.exports.boxCornerIntersection = function (q, v, w, x) {
  var y = module.exports.cdv[w];
  var z = module.exports.cdv[x];
  var A = q[w] + q[y];
  var B = v[w] + v[y];
  var C = q[w] - q[y];
  var D = v[w] - v[y];
  var E = q[x] + q[z];
  var F = v[x] + v[z];
  var G = q[x] - q[z];
  var H = v[x] - v[z];
  var I = [
    {
      [w]: C,
      [x]: G,
      d: Math.PI / 2,
    },
    {
      [w]: C,
      [x]: E,
      d: Math.PI,
    },
    {
      [w]: A,
      [x]: G,
      d: 0,
    },
    {
      [w]: A,
      [x]: E,
      d: -Math.PI / 2,
    },
  ];
  for (var J = I.length - 1; J >= 0; --J) {
    I[J].i = J;
    if (!module.exports.pointInBox(I[J][w], I[J][x], D, H, B, F, true)) {
      I.splice(J, 1);
    }
  }
  if (I.length) {
    return I;
  } else {
    return null;
  }
};
module.exports.getIntersection = function (m, q, u) {
  var v = module.exports.cdv[u];
  var w = q[u] - q[v];
  var x = m[u] - m[v];
  var y = m[u] + m[v];
  var z = q[u] + q[v];
  var A = Math.max(x, w);
  var B = Math.min(y, z);
  if (B >= A) {
    var C = (B - A) / 2;
    return {
      [u]: A + C,
      [v]: C,
    };
  }
  return null;
};
module.exports.limitRectVal = function (l, m, p) {
  var q = module.exports.cdv[p];
  if (l[p] - l[q] < m[p] - m[q]) {
    var u = (m[p] - m[q] - (l[p] - l[q])) / 2;
    l[q] -= u;
    l[p] += u;
  }
  if (l[p] + l[q] > m[p] + m[q]) {
    u = (l[p] + l[q] - (m[p] + m[q])) / 2;
    l[p] -= u;
    l[q] -= u;
  }
};
module.exports.getMaxRect = function (m, q, u) {
  var v;
  var w;
  var x;
  var y;
  var z = module.exports.cdv[q];
  var A = module.exports.cdv[u];
  for (var B = 0; B < m.length; ++B) {
    v = v == null ? m[B][q] - m[B][z] : Math.min(m[B][q] - m[B][z], v);
    x = x == null ? m[B][q] + m[B][z] : Math.max(m[B][q] + m[B][z], x);
    w = w == null ? m[B][u] - m[B][A] : Math.min(m[B][u] - m[B][A], w);
    y = y == null ? m[B][u] + m[B][A] : Math.max(m[B][u] + m[B][A], y);
  }
  return {
    [q]: (v + x) / 2,
    [u]: (w + y) / 2,
    [z]: Math.abs(x - v) / 2,
    [A]: Math.abs(y - w) / 2,
  };
};
module.exports.limitRect = function (m, q, u, v, w, x, y, z) {
  var A = module.exports.getMaxRect(x, y, z);
  var B = module.exports.cdv[y];
  var C = module.exports.cdv[z];
  var D = {
    [y]: m,
    [z]: q,
    [C]: v,
    [B]: u,
  };
  module.exports.limitRectVal(D, A, y);
  module.exports.limitRectVal(D, A, z);
  if (w == 0 || w == Math.PI) {
    var E = D[B];
    D[B] = D[C];
    D[C] = E;
  }
  return D;
};
module.exports.progressOnLine = function (m, p, q, u, v, w) {
  var x = q - m;
  var y = u - p;
  var z = Math.sqrt(x * x + y * y);
  return (
    ((x /= z) * (v - m) + (y /= z) * (w - p)) /
    Math.sqrt(Math.pow(q - m, 2) + Math.pow(u - p, 2))
  );
};
module.exports.generateSID = function (l) {
  var m = 0;
  for (var p = true; p; ) {
    p = false;
    m++;
    for (var q = 0; q < l.length; ++q) {
      if (l[q].sid == m) {
        p = true;
        break;
      }
    }
  }
  return m;
};
module.exports.levelIconId = function (l) {
  return Math.max(Math.min(config.maxLevel - 1, l.roundToNearest(2) - 1), 0);
};
module.exports.xpBarText = function (l) {
  var m = l.level > 1 ? Math.pow(l.level / config.rankVar, 2) : 0;
  return (
    parseInt(l.score - m) +
    " / " +
    parseInt(Math.pow((l.level + 1) / config.rankVar, 2) - m)
  );
};
module.exports.eloIconId = function (l) {
  return (
    Math.max(
      Math.min(config.maxELOLevel, Math.floor((l || 0) / config.eloPer)),
      1,
    ) - 1
  );
};
module.exports.eloIconHTML = function (l, m) {
  var p = module.exports.eloIconId(l);
  if (p >= 0) {
    return (
      "<img class='accountEloIcon' style='" +
      (m || "margin-bottom:-2px;") +
      "' src='./img/ranks/icon_" +
      p +
      ".png'>"
    );
  } else {
    return "";
  }
};
module.exports.getElo = function (l, m) {
  if (m) {
    return l[config.queues.filter((p) => p.id == m)[0].key];
  } else {
    return null;
  }
};
module.exports.maxElo = function (l) {
  var m = l.elo;
  if (l.elo2 > m) {
    m = l.elo2;
  } else if (l.elo4 > m) {
    m = l.elo4;
  }
  return m;
};
module.exports.copyToClipboard = function (l) {
  const m = document.createElement("textarea");
  m.value = l;
  m.setAttribute("readonly", "");
  m.style.position = "absolute";
  m.style.left = "-9999px";
  document.body.appendChild(m);
  const p =
    !!(document.getSelection().rangeCount > 0) &&
    document.getSelection().getRangeAt(0);
  m.select();
  document.execCommand("copy");
  document.body.removeChild(m);
  if (p) {
    document.getSelection().removeAllRanges();
    document.getSelection().addRange(p);
  }
};
function j(l, m) {
  return l.concat(m);
}
Array.prototype.flatMap = function (l) {
  return (function (m, p) {
    return p.map(m).reduce(j, []);
  })(l, this);
};
var msgpack = require("msgpack-lite");
// __webpack_require__(34);
module.exports.serializeNetworkMessage = function (l, ...m) {
  return msgpack.encode([l, ...m]);
};
module.exports.encodeNetworkMessage = function (l, m) {
  let p = new Uint8Array(l.length + 2);
  p.set(module.exports.getPadding(m), p.length - 2);
  p.set(l, 0);
  return p;
};
module.exports.decodePacket = function (l) {
  l = new Uint8Array(l);
  let m = module.exports.combineNibbles(l[l.length - 2], l[l.length - 1]);
  let p = l.slice(0, l.length - 2);
  let q = msgpack.decode(p);
  if (!Array.isArray(q) || q.length < 1) {
    throw "Invalid message";
  }
  return [m, q[0], q.slice(1)];
};
module.exports.rotateAhNum = function (l, m) {
  return (l + m) & 255;
};
module.exports.getPadding = function (l) {
  return [(l >> 4) & 15, l & 15];
};
module.exports.combineNibbles = function (l, m) {
  return (l << 4) + m;
};
module.exports.thumbnailSize = function (l) {
  return parseInt(l.replace(/=/g, "").length * 0.75) / 1000;
};
module.exports.rgbToHex = function (l, m, p) {
  for (var q = ((l << 16) | (m << 8) | p).toString(16); q.length < 6; ) {
    q = "0" + q;
  }
  return "#" + q;
};
module.exports.hexToRGB = (l) =>
  l
    .replace(
      /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
      (m, p, q, u) => "#" + p + p + q + q + u + u,
    )
    .substring(1)
    .match(/.{2}/g)
    .map((m) => parseInt(m, 16));
module.exports.hexFromHue = function (l) {
  var m = l / 60;
  var p = (1 - Math.abs((m % 2) - 1)) * 255;
  var q = Math.floor(m);
  return module.exports.rgbToHex(
    q < 1 || q > 4 ? 255 : q == 1 || q == 4 ? p : 0,
    q == 0 || q == 3 ? p : q == 1 || q == 2 ? 255 : 0,
    q == 0 || q == 1 ? 0 : q == 3 || q == 4 ? 255 : p,
  );
};
module.exports.versionifyUrl = function (l) {
  return l + "?build=" + version;
};
module.exports.assetsUrl = function (l, m, p) {
  if (!m && l.startsWith("/")) {
    l = l.slice(1);
  }
  return this.versionifyUrl(p ? "/" + l : "https://assets.krunker.io/" + l);
};
module.exports.userAssetsUrl = function (l, m) {
  if (!m && l.startsWith("/")) {
    l = l.slice(1);
  }
  return "https://user-assets.krunker.io/" + l;
};
module.exports.getPreview = function (l, m) {
  return module.exports.assetsUrl(
    "/textures/" +
      (l.type && l.type == 4 && !l.is3D
        ? "sprays/" + l.id
        : "previews/" +
          (l.type && l.type != 3
            ? "cosmetics/" + l.type + "_" + l.id + (l.tex ? "_" + l.tex : "")
            : m.types[l.type || 0] +
              (l.type && l.type == 3
                ? l.id +
                  (l.pat == null
                    ? l.tex == null
                      ? ""
                      : "_" + l.tex
                    : "_c" + l.pat)
                : (l.weapon || 0) +
                  "_" +
                  (l.mid == null
                    ? l.pat == null
                      ? l.tex
                        ? l.tex
                        : l.id
                      : "c" + l.pat
                    : "m" + l.mid + (l.midT == null ? "" : "_" + l.midT))))) +
      ".png",
    false,
    l.local,
  );
};
module.exports.getPreviewExport = function (l, m) {
  return module.exports
    .getPreview(l, m)
    .split("/")
    .slice(-1)
    .pop()
    .split("?")[0];
};
module.exports.getReModel = function (l, m) {
  return l.types[m.type || 0] + (m.weapon || 0) + "_" + (m.midT || m.mid);
};
module.exports.getFrameAnim = function (l, m) {
  if (l.frames) {
    return (
      "animation: " +
      m +
      l.frames +
      " " +
      (1 + l.frameT / 1000) +
      "s steps(" +
      l.frames +
      ") infinite;"
    );
  } else {
    return "";
  }
};
module.exports.isDropbox = function (l) {
  return /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?(dropbox|dropboxusercontent|dl\.dropboxusercontent)\.com\//g.test(
    l,
  );
};
module.exports.isUserAsset = function (l) {
  return /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?(user-assets\.krunker)\.io\//g.test(
    l,
  );
};
module.exports.toSocial = function (l) {
  return "./social.html?p=profile&q=" + module.exports.cleanseString(l);
};
module.exports.getFontSizeToFit = function (l, m, p) {
  var q = document.createElement("canvas").getContext("2d");
  q.font = "1px " + m;
  return p / q.measureText(l).width;
};
module.exports.ctxText = function (l, m, p, q, u) {
  l.save(1);
  l.translate(~~q, ~~u);
  l.fillStyle = p;
  l.strokeStyle = "rgba(0, 0, 0, 0.5)";
  l.lineWidth = 1;
  l.strokeText(m, 0, 0);
  l.fillText(m, 0, 0);
  l.restore();
};
module.exports.getLines = function (l, m, p) {
  for (var q = m.split(" "), u = [], v = q[0], w = 1; w < q.length; w++) {
    var x = q[w];
    if (l.measureText(v + " " + x).width < p) {
      v += " " + x;
    } else {
      u.push(v);
      v = x;
    }
  }
  u.push(v);
  return u;
};
module.exports.createCanvasText = function (q, z, A, B, C, D, E, F) {
  var G = 0;
  var H = 0;
  if (z > q) {
    G = 1;
    H = q / z;
  } else if (z < q) {
    G = z / q;
    H = 1;
  } else {
    G = 1;
    H = 1;
  }
  var I = document.createElement("canvas");
  var J = I.getContext("2d");
  I.width = H * 1024;
  I.height = G * 1024;
  if (!E) {
    J.fillStyle = D;
    J.fillRect(0, 0, I.width, I.height);
  }
  var K = B;
  J.font = K + "px GameFont";
  A = A.substring(0, config.signTextLimit - 1);
  J.textAlign = F == 2 ? "right" : F == 1 ? "center" : "left";
  var L = K * 2;
  var M = J.measureText("M").width / 2;
  M = F == 2 ? I.width - M : F == 1 ? I.width / 2 : M;
  var N = J.measureText("M").width * 1.2;
  for (var O = A.split("\\n"), P = null, Q = 0; Q < O.length; ++Q) {
    P = module.exports.getLines(J, O[Q], I.width - K);
    for (
      var R = 0;
      R < P.length &&
      (module.exports.ctxText(J, P[R], C, M, L), !((L += N) > I.height));
      ++R
    );
  }
  return I;
};
module.exports.createCanvasAD = function (l, m, p) {
  var q = document.createElement("canvas");
  q.width = 2048;
  q.height = 1024;
  var u = q.getContext("2d");
  u.fillStyle = p || "#000000";
  u.fillRect(0, 0, q.width, q.height);
  module.exports.drawMultilineText(u, l, m, q.width, q.height);
  return q;
};
module.exports.drawMultilineText = function (q, v, w, x, y) {
  var z = (module.exports.isString(v) ? v : "Your Ad Here").split(" ");
  var A = [];
  var B = 0;
  for (var C = 15; C <= 2000; C++) {
    J = C * 1.4;
    q.font = C + "px GameFont";
    var D = (x - 80) / 2;
    var E = J;
    var F = [];
    var G = z[0];
    if (q.measureText(G).width > x - 80) {
      B = C - 1;
      break;
    }
    for (var H = 1; H < z.length; H++) {
      var I = z[H];
      if (q.measureText(G + " " + I).width < x - 80) {
        G += " " + I;
      } else {
        F.push(G);
        G = I;
        E += J;
      }
    }
    F.push(G);
    if (E > y - 80) {
      B = C - 1;
      break;
    }
    A = F;
    B = C;
  }
  var J = C * 1.4;
  D = x / 2;
  E = y / 2;
  if (A.length > 1) {
    E -= (J * (A.length - 1)) / 2;
  }
  D += 40 / A.length;
  E += 80 / A.length;
  q.font = B + "px GameFont";
  q.fillStyle = w || "#e3e3e3";
  q.strokeStyle = "rgba(0, 0, 0, 0.5)";
  q.lineWidth = 1;
  for (H = 0; H < A.length; H++) {
    q.strokeText(
      A[H].trim(),
      D - q.measureText(A[H].trim()).width / 2,
      E + C / 2,
    );
    q.fillText(
      A[H].trim(),
      D - q.measureText(A[H].trim()).width / 2,
      E + C / 2,
    );
    E += J;
  }
  return C;
};
module.exports.extractProperties = function (l, m) {
  return m.reduce(function (p, q) {
    p[q] = l[q];
    return p;
  }, {});
};
module.exports.calcVoteNum = function (l) {
  if (l.level >= 50) {
    return 1.5;
  } else {
    return 1;
  }
};
module.exports.getChalProg = function (l, m) {
  var p = l.stats.chgP;
  var q = p.split(":")[0];
  var u = parseInt(l.chal) || 0;
  if (u >= config.maxChal) {
    return "";
  } else {
    if (!p.includes(":") || parseInt(q) != u) {
      l.stats.chgP =
        u + ":" + Array(m.challenges[u].list.length).fill(0).join();
    }
    return l.stats.chgP.split(":")[1];
  }
};
module.exports.getMsgType = function (l) {
  if (l.kicked) {
    return 2;
  } else if (l.banned) {
    return 3;
  } else if (l.kickedByVote) {
    return 4;
  } else if (l.arrested) {
    return 5;
  } else {
    return 1;
  }
};
module.exports.getAccountType = function (l) {
  if (l && l.featured) {
    return 3;
  } else if (l && l.premiumT) {
    return 2;
  } else if (l) {
    return 1;
  } else {
    return 0;
  }
};
module.exports.sortItems = function (l, m) {
  return l.sort(function (p, q) {
    var u = m[q.i || q.ind] ? m[q.i || q.ind].rarity : 0;
    var v = m[p.i || p.ind] ? m[p.i || p.ind].rarity : 0;
    var w = m[q.i || q.ind] ? m[q.i || q.ind].seas || 1 : 0;
    var x = m[p.i || p.ind] ? m[p.i || p.ind].seas || 1 : 0;
    if (u > v) {
      return 1;
    } else if (u < v) {
      return -1;
    } else if (w > x) {
      return 1;
    } else if (w < x) {
      return -1;
    } else {
      return (q.i || q.ind || 0) - (p.i || p.ind || 0);
    }
  });
};
module.exports.splitIds = function (l) {
  if (l) {
    return l
      .split(",")
      .filter((m) => m.length)
      .map(Number);
  } else {
    return [];
  }
};
module.exports.fixStr = function (l) {
  if (l) {
    return config.invisChar + l + config.invisChar;
  } else {
    return "";
  }
};
module.exports.cleanName = function (l) {
  if (l) {
    return l.replace("'", "\\'").replace('"', '\\"');
  } else {
    return "";
  }
};
module.exports.compressKeys = function (l) {
  return l;
};
module.exports.decompressKeys = function (l) {
  return l;
};
module.exports.filterTwitch = function (l) {
  if (l) {
    return l.replace(/[^\w]/gim, "").substring(0, 25);
  } else {
    return "";
  }
};
module.exports.filterYoutube = function (l) {
  if (l) {
    return l.replace(/[^\w_-]/gim, "").substring(0, 11);
  } else {
    return "";
  }
};
module.exports.createEmbed = function (l, m) {
  var p = document.createElement("div");
  p.style.width = "480px";
  p.style.height = "360px";
  p.style.backgroundColor = "#000";
  var q = document.createElement("iframe");
  q.style.width = "480px";
  q.style.height = "360px";
  q.style.border = "0px";
  q.src = l
    ? "https://www.youtube.com/embed/" + m + "?rel=0"
    : "https://player.twitch.tv/?channel=" + m + "&parent=krunker.io";
  p.appendChild(q);
};
module.exports.convertFaces = function (l, m) {
  if (m) {
    return parseInt(l.join(""), 2).toString(16);
  } else {
    return parseInt(l, 16).toString(2).padStart(6, "0").split("").map(Number);
  }
};
module.exports.parseColor = function (l) {
  return parseInt(l.slice(1), 16);
};
module.exports.stringifyColor = function (l) {
  return "#" + ("000000" + l.toString(16)).substr(-6);
};
module.exports.getObjKeys = function (l, m = []) {
  let p = Object.keys(l);
  if (!p.length) {
    return [null];
  }
  let q = p
    .filter((u) => !m.includes(u))
    .map((u) =>
      module.exports.getObjKeys(l[u], m).map((v) => (v ? u + "|" + v : u)),
    );
  if (q.length) {
    return q.reduce((u, v) => [...u, ...v]);
  } else {
    return [null];
  }
};
module.exports.removePrivateKeys = function (l) {
  let m = {};
  Object.keys(l)
    .filter((p) => !p.startsWith("_"))
    .forEach((p) => (m[p] = l[p]));
  return m;
};
module.exports.loadImage = function (l) {
  return new Promise((resolve) => {
    let p = new Image();
    p.onload = () => {
      resolve(p);
    };
    p.src = l;
  });
};
module.exports.easeinout = function (l) {
  return -(Math.cos(Math.PI * l) - 1) / 2;
};
module.exports.padArray = function (l, m, p) {
  return [
    ...l,
    ...Array(p)
      .fill(1)
      .map(() => m),
  ].slice(0, p);
};
module.exports.getMeleeConfig = function (l, m, p) {
  var q = m.skins[l];
  q ||= {};
  return {
    local: q.local,
    localM: q.localM,
    src: "melee/melee_" + (q.id || 0),
    texSrc: q.pat
      ? q.tex
      : q.tex
        ? "melee/melee_" + (q.id || 0) + "_" + q.tex
        : "",
    sameGlow: q.sameGlow,
    glowText: q.glow || q.sameGlow,
    emissive: q.glow || q.sameGlow ? 16777215 : null,
    movT: q.movT,
    movD: q.movD,
    pulsT: q.pulsT,
    minGlo: q.minGlo,
    frameT: q.frameT,
    tFilter: p.LinearFilter,
    frames: q.frames,
    transparent: q.opac != null,
    mat: p.MeshLambertMaterial,
    noGreen: true,
    uv2: true,
    specular: 2697513,
    shininess: 100,
    rgb: q.rgb,
    rgbS: q.rgbS,
    rgbT: q.rgbT,
    wireframe: q.wire,
    side: q.side || 0,
    opacity: q.opac || 1,
    alphaTest: q.alpha || 0,
    shaderId: q.shaderId,
  };
};
